/**
 * Sales Order Item (child table) translations.
 * Key: `Sales Order Item:${fieldname}`
 * Value: { en: string, th: string }
 */
export const salesOrderItemTranslations: Record<string, { en: string; th: string }> = {
  // Item identification
  "Sales Order Item:item_code": { en: "SKU", th: "SKU" },
  "Sales Order Item:item_name": { en: "Product Name", th: "ชื่อสินค้า" },
  "Sales Order Item:description": { en: "Description", th: "รายละเอียด" },
  "Sales Order Item:item_group": { en: "Item Group", th: "กลุ่มสินค้า" },
  
  // Quantity and pricing
  "Sales Order Item:qty": { en: "Quantity", th: "จำนวน" },
  "Sales Order Item:rate": { en: "Rate", th: "ราคา" },
  "Sales Order Item:amount": { en: "Amount", th: "จำนวนเงิน" },
  "Sales Order Item:price_list_rate": { en: "Price List Rate", th: "ราคาจากรายการราคา" },
  "Sales Order Item:base_rate": { en: "Base Rate", th: "ราคาฐาน" },
  "Sales Order Item:base_amount": { en: "Base Amount", th: "จำนวนเงินฐาน" },
  
  // Unit of measure
  "Sales Order Item:uom": { en: "UOM", th: "หน่วย" },
  "Sales Order Item:stock_uom": { en: "Stock UOM", th: "หน่วยสต็อก" },
  "Sales Order Item:conversion_factor": { en: "Conversion Factor", th: "อัตราแปลงหน่วย" },
  
  // Discounts
  "Sales Order Item:discount_amount": { en: "Discount Amount", th: "จำนวนส่วนลด" },
  "Sales Order Item:discount_percentage": { en: "Discount %", th: "ส่วนลด %" },
  "Sales Order Item:margin_type": { en: "Margin Type", th: "ประเภทมาร์จิ้น" },
  "Sales Order Item:margin_rate_or_amount": { en: "Margin Rate/Amount", th: "อัตรา/จำนวนมาร์จิ้น" },
  
  // Delivery
  "Sales Order Item:delivered_qty": { en: "Delivered Qty", th: "จำนวนที่จัดส่ง" },
  "Sales Order Item:delivered_by_supplier": { en: "Delivered by Supplier", th: "จัดส่งโดยซัพพลายเออร์" },
  
  // Warehouse
  "Sales Order Item:warehouse": { en: "Warehouse", th: "คลังสินค้า" },
  
  // Additional fields
  "Sales Order Item:image": { en: "Image", th: "รูปภาพ" },
  "Sales Order Item:idx": { en: "Index", th: "ลำดับ" },
};

